/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactSubscription extends models.AgentFieldsBase {
    getFixupPrototypeFunction() { return ArtifactSubscription.fixupPrototype; }

    static newInstance(model: Partial<ArtifactSubscription>): ArtifactSubscription {
        let obj = Object.assign(new ArtifactSubscription(), model);
        ArtifactSubscription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactSubscription>): ArtifactSubscription {
        if (!model) return null;
        return ArtifactSubscription.newInstance(<ArtifactSubscription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactSubscription) {
        if (!obj) return;

        models.ArtifactSubscription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactSubscription): boolean {
        if (models.AgentFieldsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ArtifactSubscription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * ID of the subscribed artifact
     */
    artifact_id: string;

    /**
     * ID of the artifact's agent
     */
    agent_id: string;

    /**
     * Name of the user who created the subscription.
     */
    created_by: string;

    /**
     * ID of the heatstack schedule delivering this artifact
     */
    schedule_id: string;

}
